import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import * as actions from '../actions/secmasteractions'
import { checkAccess } from '../../../actions/securityactions'
import NavBar from '../../../components/NavBar';
import SideNav from '../../../components/SideNav';
import DashboardTitle from '../../../components/DashboardTitle';
import Footer from '../../../components/Footer';
import CustomPager from '../../../components/custompager';
import UserGroups from '../components/UserGroups';
import LeftSideMenu from '../../../components/newdashboardcomponent/LeftSideMenu';
import TopBar from '../../../components/newdashboardcomponent/TopBar';

export default function UserGroupMenus() {

    const { register: registerAssignUserGroupsSearch,
        reset: resetAssignUserGroupsSearch, handleSubmit: onSubmitData, setValue: setAssignUserGroupsSearchValue, watch: watchAssignUserGroupsSearch, formState: { errors: errorsAssignUserGroupsSearch } } = useForm();


    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let checkPermissions = state.checkPermissions;
    let modalsState = state.modalsState;
    let assignUserGroups = state.assignUserGroups;
    let masters = state.masters;
    console.log("masters", masters)
    console.log("assignUserGroups", assignUserGroups)
    console.log("checkPermissions", checkPermissions)

    useEffect(() => {
        let valuesToMap = [
            { "userId": assignUserGroups.userId },
            { "userName": assignUserGroups.userName },
            { "activeFrom": assignUserGroups.activeFrom },
            { "activeTo": assignUserGroups.activeTo }

        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setAssignUserGroupsSearchValue(key, i[key])));
    }, [assignUserGroups]);

    useEffect(() => {
        async function CheckPermissions() {
            await dispatch(checkAccess({ pageMenuId: 732 }));
            await dispatch(actions.checkSecurityModuleAccess());
            //await dispatch(actions.getInsuredInfoMasters(0));
            await dispatch(actions.getSecurityMasters());
        }
        CheckPermissions();
    }, []);
    const handleAssignUserGroupsSearch = (e) => {
        let { name, value } = e.target;
        dispatch(actions.updateAssignUserGroupSearchParams({ name, value }));
    }

    const onDisplayUserGroups = async (userName, userId) => {
        {
            let name = "showUserGroupsModal";
            let value = true;
            dispatch(actions.updateModalsStateParams({ name, value }));
        }
        await dispatch(actions.getUserGroups(userId));
        dispatch(actions.resetUserGroups());
    }

    const onResetAssignUserGroupSearch = () => {
        navigate('');
        resetAssignUserGroupsSearch();
        dispatch(actions.clearAssignUserGroupSearch());
    }
    const onUserGroupSearchSubmit = async (data, e) => {
        navigate('');
        await dispatch(actions.getUserSearchResults(1, "assignUserGroups"));
    }
    const onError = (errorsAssignUserGroupsSearch, e) => console.log(errorsAssignUserGroupsSearch, e);

    const onCollapseSearch = () => {
        if (assignUserGroups.searchClass === "collapse show") {
            //    dispatch(actions.collapseSearch(true));
        } else {
            //    dispatch(actions.collapseSearch(false));
        }
    }
    const onPageChangeRequest = async (page) => {
        await dispatch(actions.getUserSearchResults(page, "assignUserGroups"))
    }

    const onCollapseUserSearchResult = () => {
        if (assignUserGroups.searchResultClass === "collapse show") {
            //    dispatch(actions.collapseSearch(true));
        } else {
            //    dispatch(actions.collapseSearch(false));
        }
    }

    const onQuotationSubmit = async (data, e) => {
        navigate('');
        resetAssignUserGroupsSearch();
    }

    {/* function renderSearchCriteria() {

        let Department = <select className="form-select fw-bold" data-toggle="select2" id="department" name="department"
            {...registerAssignUserGroupsSearch("department", { onChange: (value) => handleAssignUserGroupsSearch(value) })}
            value={assignUserGroups.department}
        >
            <option value="">-- Select Department--</option>
            {masters.departmentMasters.map((departmentMasters, index) => (
                <option value={departmentMasters.domainValue} key={departmentMasters.domainValue}>
                    {departmentMasters.domainValueName}
                </option>
            ))}
        </select>

        let UserGroup = <select className="form-select fw-bold" data-toggle="select2" id="userGroup" name="userGroup"
            {...registerAssignUserGroupsSearch("userGroup", { onChange: (value) => handleAssignUserGroupsSearch(value) })}
            value={assignUserGroups.userGroup}
        >
            <option value="">-- Select User Group--</option>
            {masters.userGroupMasters.map((userGroupMaster, index) => (
                <option value={userGroupMaster.groupId} key={userGroupMaster.groupName}>
                    {userGroupMaster.groupName}
                </option>
            ))}
        </select>

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation collapse show" id="CollapseQuoteInformation">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetAssignUserGroupsSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-2">
                        <div className="mb-3 col-md-3"></div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Department </label>
                            {Department}
                        </div>

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Group </label>
                            {UserGroup}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div id="tooltip-container2">
                            <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        </div>
                    </div>



                    <div className="row g-2">
                        <div className="mb-3 col-md-3"></div>
                        <div className="mb-3 col-md-3">
                            <div id="tooltip-container2">
                                <button type="submit" className="btn btn-success float-end"
                                    data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Save" ><i className="mdi mdi-content-save"></i> Save   </button>
                            </div>
                        </div>
                    </div>
                </form>

            </>
        )


    } */
    }

    function renderSearchCriteria() {

        let UserID = <input className={errorsAssignUserGroupsSearch.userId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="userId" required=""
            placeholder="--User ID--"
            name='userId'
            {...registerAssignUserGroupsSearch("userId", { onChange: (value) => handleAssignUserGroupsSearch(value) })}
            value={assignUserGroups.userId}
        />

        let UserName = <input className="form-control fw-bold"
            placeholder="--User Name--"
            id="userName"
            name="userName"
            {...registerAssignUserGroupsSearch("userName", { onChange: (value) => handleAssignUserGroupsSearch(value) })}
            value={assignUserGroups.userName}
        />

        let ActiveFrom = <input className={errorsAssignUserGroupsSearch.activeFrom ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="date" id="activeFrom" required=""
            placeholder="DD/MM/YYYY"
            name='activeFrom'
            {...registerAssignUserGroupsSearch("activeFrom", { onChange: (value) => handleAssignUserGroupsSearch(value) })}
            value={assignUserGroups.activeFrom}
        />
        let ActiveTo = <input className={errorsAssignUserGroupsSearch.activeTo ? 'form-control is-invalid' : 'form-control fw-bold'}
            type="date" id="activeTo" required=""
            placeholder="DD/MM/YYYY"
            name='activeTo'
            {...registerAssignUserGroupsSearch("activeTo", { min: { value: assignUserGroups.activeFrom, message: "This Date should be greater than or equal to Active From Date" }, onChange: (value) => handleAssignUserGroupsSearch(value) })}
            value={assignUserGroups.activeTo}
        />

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className={assignUserGroups.searchClass} id="CollapseSearchComponents"
                    onSubmit={onSubmitData(onUserGroupSearchSubmit, onError)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    {checkPermissions.hasResetUserSearch && <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetAssignUserGroupSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User ID </label>
                            {UserID}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> User Name </label>
                            {UserName}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Active From </label>
                            {ActiveFrom}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputPassword4" className="form-label"> Active To </label>
                            {ActiveTo}
                            {errorsAssignUserGroupsSearch.activeTo?.message && <span>{errorsAssignUserGroupsSearch.activeTo?.message}</span>}
                        </div>

                    </div>

                    <div id="tooltip-container2">
                        {checkPermissions.hasUserSearch && <button type="submit" className="btn btn-primary float-end"
                            data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        }
                    </div>

                </form>

            </>

        )
    }

    function renderUserListing() {
        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div className={assignUserGroups.searchResultClass} id="CollapseSearchResult">
                    <div className="row g-2">
                        <div className="mb-1 col-md-6">
                            {!assignUserGroups.showSearchResult && <h5 className="alert alert-danger">No Records Found...</h5>}
                        </div>
                    </div>
                    {assignUserGroups.showSearchResult &&
                        <>
                            <div className="table-responsive">
                                <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                                    <thead>

                                        <tr>
                                            <th>Actions</th>
                                            <th /* onClick={() => updateSortString('UserID')} */>User ID ⬇️ </th>
                                            <th /* onClick={() => updateSortString('UserName')} */>User Name ⬇️</th>
                                            <th /* onClick={() => updateSortString('Designation')} */>User Designation ⬇️</th>
                                            <th /* onClick={() => updateSortString('MobileNo')} */>User Mobile ⬇️</th>
                                            <th /* onClick={() => updateSortString('Email')} */>User Email ⬇️</th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {assignUserGroups.searchResult.result.map((searchResult, index) => (

                                            <tr key={searchResult.userId}>
                                                <td>
                                                    {checkPermissions.hasViewUser && <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                        data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" onClick={() => onDisplayUserGroups(searchResult.userName, searchResult.userId)}>
                                                        <i className="dripicons-preview"></i>
                                                    </button>
                                                    }
                                                </td>

                                                <td> {searchResult.userId} </td>
                                                <td> {searchResult.userName} </td>
                                                <td> {searchResult.designation} </td>
                                                {/* <td> {searchResult.userGroup} </td> */}
                                                <td> {searchResult.mobileNo} </td>
                                                <td> {searchResult.email} </td>

                                            </tr>

                                        ))}

                                    </tbody>
                                </table>
                            </div>
                            <div className="float-end">
                                <CustomPager onPageChangeRequest={onPageChangeRequest} pagedResult={assignUserGroups.searchResult} />
                            </div>
                        </>
                    }
                </div>



            </>
        )
    }

    return (

        <>
            <div className="wrapper">
                <LeftSideMenu />
                <div class="content-page">
                    <TopBar />
                    <div class="content">
                        <DashboardTitle />
                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>User Group Menus</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        {assignUserGroups.isSubmit &&
                            <div className="content">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card ribbon-box">
                                            <div className="card-body">
                                                <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>User Listing</div>
                                                <div className="btn-group float-end" id="tooltip-container2">
                                                    <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchresultscollapsableButton"
                                                        data-bs-toggle="collapse" data-bs-target="#CollapseSearchResult"
                                                        aria-expanded="false" aria-controls="CollapseSearchResult" onClick={() => onCollapseUserSearchResult()}>
                                                        <i className="mdi mdi-arrow-up-down"></i>
                                                    </button>
                                                </div>
                                                <h5 className="text-primary float-end mt-0"> </h5>
                                                <div className="ribbon-content">
                                                    {renderUserListing()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {modalsState.showUserGroupsModal &&
                            <UserGroups />
                        }
                    </div>
                    <Footer />
                </div>

            </div>
        </>
    )
}